import {api} from 'app/services/api';
import {changeHeaderText} from 'app/actions/headerActions';
import {catchDataError} from 'app/helpers/apiHelpers';
import {updateHistory} from 'app/actions/historyActions';
import {initData} from 'app/routes/competition/CompetitionPageReducer';
import {updateHttpErrorSubroute} from 'app/components/error/ErrorHandlerActions';
import {DistrictUnsetParentFactory} from 'app/models/appBar/DistrictUnsetParentFactory';

const getDistrictCompetitions = (ageGroup, category, districtSlug) => {
  return api.get(`/competitions?ageGroup=${ageGroup}&category=${category}&district=${districtSlug}&limit=0`);
};

const getAgeGroupsByDistrict = districtSlug => {
  return api.get(`/districts/${districtSlug}/ageGroups`);
};

function fetchingDefaultAgeGroups() {
  return {
    type: 'COMPETITION_DEFAULT_AGE_GROUPS_FETCHING',
  };
}

function updateDefaultAgeGroups(data) {
  return {
    type: 'COMPETITION_DEFAULT_AGE_GROUPS_UPDATE',
    data,
  };
}

function updateOpenAgeGroup(key) {
  return {
    type: 'OPEN_AGE_GROUP_UPDATE',
    key,
  };
}

function fetchingDefaultCompetitions() {
  return {
    type: 'COMPETITION_DEFAULT_COMPETITIONS_FETCHING',
  };
}

function updateDefaultCompetitions(data) {
  return {
    type: 'COMPETITION_DEFAULT_COMPETITIONS_UPDATE',
    data,
  };
}

function errorDefaultCompetitions(data) {
  return {
    type: 'COMPETITION_DEFAULT_COMPETITIONS_ERROR',
    data,
  };
}

export const getActiveKeyFromPreloadedCompetitions = competitionTypes => {
  return competitionTypes.reduce(
    (key, competitionCategory) =>
      competitionCategory.ageGroups.reduce(
        (key, ageGroup) => (ageGroup.competitionSeasons ? `${competitionCategory.category.id}_${ageGroup.slug}` : key),
        null
      ) ?? key,
    null
  );
};

function fetchingCompetitionDefaultAgeGroupsSSR(slug, activeKey) {
  return function (dispatch) {
    return getAgeGroupsByDistrict(slug)
      .then(response => {
        dispatch(
          updateHistory('undefined', {
            store: 'CompetitionDefaultPage',
            data: {
              ...initData,
              ageGroups: {isFetching: false, items: response.data},
              openAgeGroup: activeKey ?? getActiveKeyFromPreloadedCompetitions(response.data),
            },
          })
        );
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(updateHttpErrorSubroute(errorData));
      });
  };
}

function fetchingCompetitionDefaultAgeGroups(slug, dispatchRedux, activeKey) {
  return function (dispatch, state) {
    const {items, error} = state.ageGroups;
    if (items.length > 0 || error) {
      return;
    }
    dispatch(fetchingDefaultAgeGroups());
    return getAgeGroupsByDistrict(slug)
      .then(response => {
        dispatch(
          updateDefaultAgeGroups({
            items: response.data,
            openAgeGroup: activeKey ?? getActiveKeyFromPreloadedCompetitions(response.data),
          })
        );
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatchRedux(updateHttpErrorSubroute(errorData));
      });
  };
}

function fetchingCompetitionDefaultCompetitionsByAgeGroupSSR(ageGroupSlug, category, districtSlug) {
  return function (dispatch) {
    if (!ageGroupSlug || !category) {
      return;
    }
    const key = `${category}_${ageGroupSlug}`;

    return getDistrictCompetitions(ageGroupSlug, category, districtSlug)
      .then(response => {
        dispatch(
          updateHistory('undefined', {
            store: 'CompetitionDefaultPage',
            data: {competitions: {isFetching: false, error: null, [key]: response.data}},
          })
        );
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(
          updateHistory('undefined', {
            store: 'CompetitionDefaultPage',
            data: {competitions: {isFetching: false, error: errorData}},
          })
        );
      });
  };
}

function fetchingCompetitionDefaultCompetitionsByAgeGroup(ageGroupSlug, category, districtSlug) {
  return function (dispatch, state) {
    if (!ageGroupSlug || !category) {
      return;
    }
    const {competitions} = state;
    const key = `${category}_${ageGroupSlug}`;
    if (key in competitions) {
      return;
    }
    dispatch(fetchingDefaultCompetitions());
    return getDistrictCompetitions(ageGroupSlug, category, districtSlug)
      .then(response => {
        dispatch(updateDefaultCompetitions({key, items: response.data}));
      })
      .catch(error => {
        const errorData = catchDataError(error);
        dispatch(errorDefaultCompetitions(errorData));
      });
  };
}

function setCompetitionCrawlerHeader() {
  return function (dispatch) {
    const parent = DistrictUnsetParentFactory.create();

    dispatch(
      changeHeaderText({
        title: 'FuPa Ligen',
        parent,
      })
    );
  };
}

export {
  fetchingCompetitionDefaultAgeGroupsSSR,
  fetchingCompetitionDefaultAgeGroups,
  fetchingCompetitionDefaultCompetitionsByAgeGroupSSR,
  fetchingCompetitionDefaultCompetitionsByAgeGroup,
  setCompetitionCrawlerHeader,
  updateOpenAgeGroup,
};
